export default "__VITE_ASSET__BxTPzn4S__"